import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { createContext, useContext } from 'react';
var FormControlContext =
/*#__PURE__*/
createContext({
  isRequired: false,
  isInvalid: false,
  isValid: false,
  isDisabled: false,
  isReadOnly: false
});

var useFormControlContext = function useFormControlContext() {
  var context = useContext(FormControlContext);
  return context;
};

var useFormControl = function useFormControl(props) {
  var context = useFormControlContext();

  if (!context) {
    return props;
  }

  var keys = Object.keys(context);
  return keys.reduce(function (acc, prop) {
    acc[prop] = props[prop];

    if (context && !props[prop]) {
      acc[prop] = context[prop];
    }

    return acc;
  }, {});
};

export { FormControlContext, useFormControl, useFormControlContext };